// @flow
import { combineReducers } from "redux";

import Layout from "./layout/reducers";
import Login from "./login/reducers";
import Order from "./order/reducers";
import Project from "./project/reducers";

const rootReducer = combineReducers({
  Layout,
  Login,
  Order,
  Project,
});

export default rootReducer;
